module.exports = __webpack_public_path__ + "static/Natalie Chin.c8eac33e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Natalie Chin.jpg
// module id = 1225
// module chunks = 6166952557895